import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { FileUploadModule } from '@iplab/ngx-file-upload';
import { CustomizerSettingsService } from '../../customizer-settings/customizer-settings.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Endpoints } from '../../customs/endpoints';
import { ApiService } from '../../customs/_services/api.service';
import { LoggerService } from '../../customs/_services/logger.service';
import { DialogService } from '../../customs/_modal/dialog.service';
import { environment } from '../../../environments/environment';
import { OverlayContainer } from "@angular/cdk/overlay";
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { catchError, finalize, tap, of } from 'rxjs';

@Component({
    selector: 'app-labo',
    standalone: true,
    imports: [
        ReactiveFormsModule,
        CommonModule,
        RouterOutlet,
        RouterLink,
        RouterLinkActive,
        MatButtonModule,
        MatInputModule,
        MatFormFieldModule,
        MatSelectModule,
        FileUploadModule
    ],
    templateUrl: './labo.component.html',
    styleUrl: './labo.component.scss',
    providers: [Endpoints]
})
export class LaboComponent {
    isToggled = false;
    laboratoryDetails: any = {}; // Initialisation pour éviter undefined
    laboId: string = '1'; // ID du laboratoire par défaut
    editForm: FormGroup;
    isEditing = false; // Gestion de l'affichage du formulaire

    constructor(
        private apiService: ApiService,
        private endpoints: Endpoints,
        private spinner: NgxSpinnerService,
        private loggerService: LoggerService,
        private dialogService: DialogService,
        private fb: FormBuilder,
        private router: Router,
        public themeService: CustomizerSettingsService,
        private http: HttpClient,
        private overlayContainer: OverlayContainer
    ) {
        this.initializeEditForm();
    }

    ngOnInit(): void {
        this.fetchLaboratoryDetails(this.laboId);
    }

    toggleRTLEnabledTheme() {
        this.themeService.toggleRTLEnabledTheme();
    }

    toggleEditForm() {
        this.isEditing = !this.isEditing;
    }

    fetchLaboratoryDetails(LaboratoryId: string) {
        this.spinner.show();
        const LaboratoryUrl = `${this.endpoints.laboratory_base_endpoint.replace(/\/$/, '')}/${LaboratoryId}`;

        console.log('Fetching laboratory details from:', LaboratoryUrl); // Debugging

        this.http.get(LaboratoryUrl).subscribe({
            next: (response: any) => {
                if (response && response.status) {
                    this.laboratoryDetails = response.data || {}; // Assurer que c'est défini
                    this.loggerService.log('Laboratory_details', this.laboratoryDetails);
                    this.initializeEditForm();
                }
            },
            error: (error) => {
                console.error('Error fetching laboratory details:', error);
                this.handleError(error);
            },
            complete: () => this.spinner.hide()
        });
    }

    handleError(error: { status: number }) {
        this.spinner.hide();
        this.loggerService.log('error', error);

        if (error.status === 401) {
            this.dialogService.open('Token Expired. Redirecting to Login Page', environment.error_message_type, 'danger', environment.error_icon);
            setTimeout(() => {
                window.location.href = '/authentication';
            }, 3000);
        } else if (error.status === 500) {
            this.dialogService.open('Internal Server Error!!!', environment.error_message_type, 'danger', environment.error_icon);
        } else {
            this.dialogService.open('Bad Request. Please Try Again!', environment.error_message_type, 'danger', environment.error_icon);
        }
    }

    onEditSubmit() {
        if (this.editForm.valid) {
            this.spinner.show();
            const formData = this.editForm.value;

            this.apiService.put(formData, this.endpoints.laboratory_base_endpoint, formData.id).pipe(
                tap((response: any) => {
                    if (response.status) {
                        this.laboratoryDetails = response.data;
                        this.dialogService.open('Infos du laboratoire mises à jour avec succès', environment.info_message_type, 'success', environment.info_icon);
                        this.initializeEditForm();
                        this.fetchLaboratoryDetails(formData.id);
                    }
                }),
                catchError((error) => {
                    this.spinner.hide();
                    this.handleError(error);
                    return of(null);
                }),
                finalize(() => {
                    this.spinner.hide();
                })
            ).subscribe();
        } else {
            this.loggerService.log('invalid_form_data', this.editForm.value);
            this.dialogService.open('Form is invalid. Please check the fields.', environment.error_message_type, 'danger', environment.error_icon);
        }
    }

    initializeEditForm() {
        this.editForm = this.fb.group({
            id: [this.laboratoryDetails?.id || '1'],
            raisonSociale: [this.laboratoryDetails?.raisonSociale || '', Validators.required],
            ice: [this.laboratoryDetails?.ice || '', Validators.required],
            type: [this.laboratoryDetails?.type || ''],
            capital: [this.laboratoryDetails?.capital || '', Validators.required],
            telephone: [this.laboratoryDetails?.telephone || '', Validators.required],
            adresseMail: [this.laboratoryDetails?.adresseMail || '', [Validators.required, Validators.email]],
            siteWeb: [this.laboratoryDetails?.siteWeb || ''],
            registreCommerce: [this.laboratoryDetails?.registreCommerce || '', Validators.required],
            patente: [this.laboratoryDetails?.patente || '', Validators.required],
            cnss: [this.laboratoryDetails?.cnss || '', Validators.required],
            i_f: [this.laboratoryDetails?.i_f || '', Validators.required],
            fax: [this.laboratoryDetails?.fax || '', Validators.required]
        });
    }
}
